<template>
  <div class="freight-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleFreightModal('add')">+ 添加运费模版</div>
        <el-table :data="freightList" class="order-table table no-border-table" ref="orderTable" :header-cell-style="{
          border: 'none',
          color: '#333',
          background: '#f6f6f6',
          borderBottom: '1px solid #E8E8E8',
          height: '54px',
        }" :row-style="{
  height: '54px',
}">
          <el-table-column type="index" :index="tableIndex" align="center" label="编号" width="120"></el-table-column>
          <el-table-column prop="name" align="center" label="运费模版名称"></el-table-column>
          <el-table-column prop="type" align="center" label="类型">
            <div slot-scope="scope">
              {{ typeMap[scope.row.way] }}
            </div>
          </el-table-column>
          <el-table-column prop="created" align="center" label="创建时间"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex; justify-content: center">
              <div>
                <button size="mini" class="table-btn" @click="handleFreightModal('edit', scope.row)">
                  编辑
                </button>
                <button size="mini" class="table-btn" @click="handleDelete(scope.row.id)">
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" background
          layout="total, prev, pager, next, jumper" :page-size="size" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addFreightShow" class="dialog" width="1040px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "发布" : "编辑") + "运费" }}
      </div>
      <el-form ref="form" :rules="rules" :model="addFreightForm" class="freight-form" label-width="auto">
        <el-form-item label="模版名称" prop="name" class="form-item">
          <el-input placeholder="请输入模版名称" class="add-renovation-input" v-model="addFreightForm.name"
            style="width: 620px"></el-input>
          <span style="margin-left: 12px">名称不要超过十六个字</span>
        </el-form-item>
        <!-- <el-form-item label="计价方式" prop="type" class="form-item">
          <el-radio-group v-model="addFreightForm.type">
            <el-radio :label="1">按件数</el-radio>
            <el-radio :label="2">按重量</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="计价设置" prop="gid" class="form-item">
          <div class="table">
            <table>
              <tr>
                <th>
                  <span>配送范围</span>
                </th>
                <th>首件数/件</th>
                <th>首费用/元</th>
                <th>续件数/件</th>
                <th>续费/元</th>
                <th></th>
              </tr>
              <tr>
                <td>
                  <span>默认地区</span>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small"
                    v-model.number="addFreightForm.firstAmount"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small"
                    v-model.number="addFreightForm.firstFee"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small"
                    v-model.number="addFreightForm.continueAmount"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small"
                    v-model.number="addFreightForm.continueFee"></el-input>
                </td>
                <td></td>
              </tr>
              <tr v-for="(item, index) in list" :key="index">
                <td>
                  <span v-for="(area, areaIndex) in item.freightArea" :key="area">{{ provinceMap[area]
                  }}<span v-if="areaIndex !== item.freightArea.length - 1">，</span></span>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small" v-model.number="item.firstAmount"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small" v-model.number="item.firstFee"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small"
                    v-model.number="item.continueAmount"></el-input>
                </td>
                <td>
                  <el-input style="width: 100px" placeholder="" size="small" v-model.number="item.continueFee"></el-input>
                </td>
                <td @click="deleteTemplate(index)">
                  <svg class="delete" aria-hidden="true">
                    <use xlink:href="#icon-sous-qx"></use>
                  </svg>
                </td>
              </tr>
            </table>
            <div class="btn" @click="changeAreaModal" style="margin-left: 20px">
              + 新增配送范围
            </div>
          </div>
        </el-form-item>
        <el-form-item label="不发货地区" prop="noShipment" class="form-item">
          <div class="no-shipment-box">
            <div class="no-shipment">{{ freightInfo.noShipmentName ? freightInfo.noShipmentName.join(',') : '' }}</div>
            <div class="btn" @click="changeNoAreaModal" style="margin-left: 20px">
              + 新增不发货地区
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addFreightShow = false">取 消</el-button>
        <el-button class="confirm-btn btn" @click="handleFreight">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="选择地区" width="800px" :visible.sync="areaShow">
      <div class="area-box">
        <div class="area-item" v-for="item in provinceList" :key="item.code">
          <el-checkbox :disabled="areaObj[item.code]" v-model="provinceObj[item.code]">{{ item.name }}</el-checkbox>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="areaShow = false">取 消</el-button>
        <el-button class="btn confirm-btn" @click="saveArea">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="不发货地区" width="880px" :visible.sync="visible" :close-on-click-modal="true">
      <div class="area-box2">
        <div class="area-item" v-for="item in areaArr" :key="item.value">
          <el-popover width="600" trigger="click" placement="bottom-start">
            <div class="area-box2 county">
              <div class="area-item" v-for="city in item.children" :key="city.value">
                <el-popover width="600" trigger="click" placement="bottom-start">
                  <div class="area-box2 city">
                    <div class="area-item" v-for="county in city.children" :key="county.value">
                      <div class="province">
                        <el-checkbox v-model="county.checked" @change="
                          (val) =>
                            changeArea(val, 'county', item, city, county)
                        " class="checkbox"></el-checkbox>
                        {{ county.label }}
                      </div>
                    </div>
                  </div>
                  <div slot="reference" class="province">
                    <el-checkbox :indeterminate="city.indeterminate" v-model="city.checked"
                      @change="(val) => changeArea(val, 'city', item, city)" class="checkbox"></el-checkbox>
                    {{ city.label }}
                    <i class="el-icon-caret-bottom" v-if="city.children"></i>
                  </div>
                </el-popover>
              </div>
            </div>
            <div slot="reference" class="province">
              <el-checkbox :indeterminate="item.indeterminate" v-model="item.checked"
                @change="(val) => changeArea(val, 'province', item)" class="checkbox"></el-checkbox>
              {{ item.label }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </el-popover>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="visible = false">取 消</el-button>
        <el-button class="btn confirm-btn" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'freight',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '运费设置'
      },
      typeMap: {
        1: '按件数',
        2: '按重量'
      },
      freightList: [], // 轮播列表
      rules: {},
      areaShow: false,
      currentSort: 0,
      addFreightForm: {
        way: 1,
        name: '',
        firstAmount: null,
        firstFee: null,
        continueAmount: null,
        continueFee: null,
        freeShipping: 0,
        noShipment: []
      },
      list: [],
      provinceList: [],
      provinceObj: {},
      provinceMap: {},
      areaObj: {},
      addFreightShow: false,
      freightId: null,
      type: 'add',

      freightInfo: {
        defaultArea: {
          noShipment: []
        }
      },
      visible: false,
      areaArr: [],
      areaInfo: {},
      flag: false
    };
  },
  mounted() {
    // 获取列表
    this.getFreightList();
    this.getAreaList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getGoodsList();
    },
    // 获取轮播列表
    getFreightList() {
      this.loading++;
      this.httpGet(this.$root.getFreightList, {
        page: this.currentPage,
        size: this.size
      }).then(
        (res) => {
          this.loading--;
          this.freightList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getAreaList() {
      this.loading++;
      this.httpGet(AREA_OSS, {}).then(
        (res) => {
          this.loading--;
          let list = [];
          let obj = {};
          for (let key in res.province_list) {
            list.push({
              code: key,
              name: res.province_list[key]
            });
            obj[key] = false;
          }
          this.provinceList = list;
          this.provinceObj = obj;
          this.provinceMap = res.province_list;
          this.areaInfo = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    setNoShipment() {
      let countyObj = {};
      let areaInfo = { ...this.areaInfo };
      for (let countyId in areaInfo.county_list) {
        let cId = (countyId + '').substring(0, 4);
        if (countyObj[cId]) {
          countyObj[cId].push({
            label: areaInfo.county_list[countyId],
            value: +countyId,
            checked: this.areaObj[+countyId] || false,
            indeterminate: false
          });
        } else {
          countyObj[cId] = [
            {
              label: areaInfo.county_list[countyId],
              value: +countyId,
              checked: this.areaObj[+countyId] || false,
              indeterminate: false
            }
          ];
        }
      }
      // 根据省 划分市
      let areaArr = [];
      let cityObj = {};
      // let cityEmptyObj = {};
      for (let cityId in areaInfo.city_list) {
        let pId = (cityId + '').substring(0, 2);
        if (cityObj[pId]) {
          cityObj[pId].push({
            label: areaInfo.city_list[cityId],
            value: +cityId,
            children: countyObj[(cityId + '').substring(0, 4)],
            checked: this.areaObj[+cityId] || false,
            indeterminate: false
          });
        } else {
          cityObj[pId] = [
            {
              label: areaInfo.city_list[cityId],
              value: +cityId,
              children: countyObj[(cityId + '').substring(0, 4)],
              checked: this.areaObj[+cityId] || false,
              indeterminate: false
            }
          ];
        }
      }
      for (let provinceId in areaInfo.province_list) {
        areaArr.push({
          value: +provinceId,
          label: this.areaInfo.province_list[provinceId],
          children: cityObj[(provinceId + '').substring(0, 2)],
          checked: this.areaObj[+provinceId] || false,
          indeterminate: false
        });
      }
      console.log(areaArr);

      areaArr.forEach((province) => {
        let provinceChecked = province.checked;
        province.children.forEach((city) => {
          if (provinceChecked) city.checked = true;
          let cityChecked = city.checked;
          let children = city.children || [];
          children.forEach((county) => {
            if (cityChecked) county.checked = true;
          });
        });
      });

      areaArr.forEach((province) => {
        province.children.forEach((city) => {
          let children = city.children || [];
          let num = children.filter((county) => {
            return county.checked;
          }).length;
          city.indeterminate = Boolean(num && num !== children.length);
          city.checked = num === children.length;
        });
      });

      areaArr.forEach((province) => {
        let indeterminate = false;
        let checked = true;
        province.children.forEach((city) => {
          if (city.indeterminate || city.checked) indeterminate = true;
          if (!city.checked) checked = false;
        });
        if (checked) indeterminate = false;
        province.indeterminate = indeterminate;
        province.checked = checked;
      });

      this.areaArr = areaArr;
      this.visible = true;
    },
    changeArea(val, type, province, city, county) {
      // console.log(val);
      // console.log(this.areaArr);
      let filterArr = [];
      let length = 0;
      let flag = false;
      switch (type) {
        case 'province':
          province.indeterminate = false;
          province.children = province.children.map((item) => {
            item.children.forEach((item2) => {
              item2.checked = val;
            });
            return { ...item, checked: val };
          });
          break;
        case 'city':
          city.indeterminate = false;
          city.children = city.children.map((item) => {
            return { ...item, checked: val };
          });
          flag = false;
          filterArr = province.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          province.indeterminate = Boolean(
            length && length !== province.children.length
          );
          if (flag) province.indeterminate = true;
          province.checked = length === province.children.length;
          break;
        case 'county':
          flag = false;
          filterArr = city.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          city.indeterminate = Boolean(
            length && length !== city.children.length
          );
          if (flag) city.indeterminate = true;
          city.checked = length === city.children.length;

          flag = false;
          filterArr = [];
          length = 0;
          filterArr = province.children.filter((item) => {
            if (item.indeterminate) flag = true;
            return item.checked;
          });
          length = filterArr.length;
          province.indeterminate = Boolean(
            length && length !== province.children.length
          );
          if (flag) province.indeterminate = true;
          province.checked = length === province.children.length;
          break;
        default:
          break;
      }
    },
    getInfo(id) {
      this.loading++;
      this.httpGet(this.$root.getFreightInfo, {
        id
      }).then(
        (res) => {
          this.loading--;
          this.list = res.info.newArea.map(item => {
            return {
              firstAmount: item.firstAmount,
              firstFee: item.firstFee,
              continueAmount: item.continueAmount,
              continueFee: item.continueFee,
              freightArea: item.freightArea
            };
          });
          let addFreightForm = { ...this.addFreightForm };
          for (let key in this.addFreightForm) {
            addFreightForm[key] = res.info.defaultArea[key];
          }
          this.addFreightForm = addFreightForm;
          // console.log(res.info.defaultArea);
          // console.log(addFreightForm);
          this.freightInfo = res.info;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleFreightModal(type, rowData) {
      this.type = type;
      this.areaObj = {};
      if (type === 'edit') {
        this.freightId = rowData.id;
        this.getInfo(rowData.id);
      } else {
        this.list = [];
        this.freightInfo.noShipmentName = [];
        this.freightInfo.defaultArea.noShipment = [];
        this.addFreightForm = {
          way: 1,
          name: '',
          firstAmount: null,
          firstFee: null,
          continueAmount: null,
          continueFee: null,
          freeShipping: 0,
          noShipment: []
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addFreightShow = true;
    },
    handleDelete(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该运费模板吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteFreight, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getFreightList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    addTemplate() { },
    deleteTemplate(index) {
      this.list.splice(index, 1);
    },
    handleConfirm() {
      let arr = [];
      for (let i = 0; i < this.areaArr.length; i++) {
        let province = this.areaArr[i];
        if (province.checked) {
          arr.push(province.value);
          continue;
        }
        for (let j = 0; j < province.children.length; j++) {
          let city = province.children[j];
          if (city.checked) {
            arr.push(city.value);
            continue;
          }
          let children = city.children || [];
          for (let k = 0; k < children.length; k++) {
            let county = children[k];
            if (county.checked) {
              arr.push(county.value);
            }
          }
        }
      }
      this.addFreightForm.noShipment = arr;
      console.log(this.addFreightForm);

      this.freightInfo.defaultArea.noShipment = arr;


      this.loading++;
      this.httpPost(this.$root.getAreaName, {
        list: arr
      }).then(
        (res) => {
          this.loading--;
          this.freightInfo.noShipmentName = res;
          this.visible = false;
        },
        (res) => {
          this.loading--;
          this.visible = false;
          this.$message.error(res);
        }
      );
    },
    //
    handleFreight() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addFreight
              : this.$root.updateFreight;
          let inputData =
            this.type === 'add'
              ? {
                ...this.addFreightForm
              }
              : {
                ...this.addFreightForm,
                id: this.freightId
              };
          let method = this.type === 'add' ? 'httpPost' : 'httpPut';
          this.loading++;
          this[method](url, {
            defaultArea: {
              ...inputData
              // noShipment: [],
              // freeShipping: 0
            },
            newArea: this.list
          }).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addFreightShow = false;
              this.getFreightList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    changeAreaModal() {
      this.flag = false;
      let obj = { ...this.provinceObj };
      for (let key in obj) {
        obj[key] = false;
      }
      this.provinceObj = obj;
      let areaObj = {};
      this.list.forEach((item) => {
        item.freightArea.forEach((area) => {
          areaObj[area] = true;
        });
      });
      this.areaObj = areaObj;
      this.areaShow = true;
    },
    changeNoAreaModal() {
      // console.log(this.freightInfo.defaultArea, 123);
      let list = this.freightInfo.defaultArea.noShipment || [];
      let obj = {};
      list.forEach((item) => {
        obj[item] = true;
      });
      this.areaObj = obj;
      this.setNoShipment();
    },
    saveArea() {
      console.log(this.provinceObj);
      if (this.flag) return;
      this.flag = true;
      let list = [];
      for (let key in this.provinceObj) {
        if (this.provinceObj[key]) {
          list.push(+key);
        }
      }
      if (!list.length) {
        return;
      }
      this.list.push({
        freightArea: list,
        firstAmount: null,
        firstFee: null,
        continueAmount: null,
        continueFee: null
      });
      this.areaShow = false;
      // this.flag = false;
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.freight-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .btn {
    // width: 100px;
    display: inline-block;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    confirm-btn();
    font-size: 14px;
    margin-bottom: 16px;
    // margin: 16px 0;
  }

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .freight-form {
    margin-top: 16px;
    margin-bottom: 15px;
    // padding-left: 60px;
    padding: 0 15px;

    .form-item {
      .table {
        border: 1px solid #E8E8E8;
        padding: 0 8px;
        width: 874px;
      }

      .delete{
        width: 24px;
        height: 24px;
      }

      table {
        width: 100%;
        border-spacing: 0 8px;
        border-collapse: separate;

        th {
          height: 45px;
          text-align: center;
        }

        td {
          height: 45px;
          text-align: center;
          background: #F7F8FA;
        }

        tr {
          th:nth-of-type(1), td:nth-of-type(1) {
            width: 300px;
            text-align: center;
          }

          th:nth-last-of-type(1), td:nth-last-of-type(1) {
            width: 60px;
            text-align: center;
            flex-x(center);
          }

          &:nth-of-type(n+2) {
            // background: #F7F8FA;
            // margin-bottom: 8px;
            // border-bottom: 8px solid #fff;
            // height: 54px;
            // padding-bottom: 8px;
          }
        }
      }

      .no-shipment-box {
        width: 100%;
        flex-x(flex-start);

        .btn {
          margin-bottom: 0;
        }
      }

      .no-shipment {
        min-height: 48px;
        border-radius: 5px;
        background: #F7F8FA;
        padding: 0 30px;
        box-sizing: border-box;
        flex: 1;
      }
    }

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .area-box {
    flex-x(flex-start);
    flex-wrap: wrap;
    padding: 16px;

    .area-item {
      // margin-right: 32px;
      line-height: 40px;
      min-width: 145px;
    }
  }
}

.area-box2 {
  flex-x(flex-start);
  flex-wrap: wrap !important;

  .area-item {
    width: 168px;
    line-height: 40px;
    word(14px, #333);
    flex-x(flex-start);

    .province {
      width: 100%;
      flex-x(flex-start);
      overflow: hidden;
      flex-wrap: nowrap;
      white-space: nowrap;

      .checkbox {
        margin-right: 12px;
        // align-self: flex-start;
      }
    }
  }

  &.city, &.county {
    .area-item {
      width: (1 / 3) * 100%;
    }
  }
}
</style>
